import { useMutation, useQueryClient } from "@tanstack/react-query";

import { setFootprintingDairyFeedProduction, setFootprintingDairyFeedProductionAdmin } from "services";

import { footprintingDairyPrimaryQueryKeys, getEnvironment, invalidateAndRefecthQueries } from "utils";

import { FOOTPRINTING_DAIRY_FEED_PRODUCTION } from "consts";

import { DairyFeedProduction } from "models";

export const useMutateFootprintingDairyFeedProduction = (
  feedInformationId: string,
  primaryDataId: string,
  farmId: string,
  year: number,
  onSuccess?: () => void
) => {
  const isAdmin = getEnvironment().admin;
  const queryClient = useQueryClient();
  return useMutation(
    {
      mutationKey: [FOOTPRINTING_DAIRY_FEED_PRODUCTION, feedInformationId, isAdmin],
      mutationFn: (data: DairyFeedProduction) =>
        (isAdmin ? setFootprintingDairyFeedProductionAdmin : setFootprintingDairyFeedProduction)(feedInformationId, data),
      onSuccess: async () => {
        await invalidateAndRefecthQueries(queryClient, [
          [FOOTPRINTING_DAIRY_FEED_PRODUCTION, feedInformationId, isAdmin],
          ...footprintingDairyPrimaryQueryKeys(primaryDataId, farmId, year, isAdmin),
        ]);
        onSuccess?.();
      },
    },
    queryClient
  );
};
